export const apimSubscriptionKey = process.env.APIM_SUBSCRIPTION_KEY;
export const apiBaseUrl = process.env.NEXT_PUBLIC_APIBASEURL;
export const oktaTokenEndpoint = "/oauth/token";
export const PLP_END_POINT_SUBSCRIPTION_KEY = "/lw/plp";
export const SSR_PLP_FL = [
  "Color.SKU.Details_ss",
  "Color.GST.Details_ss",
  "ProductLocalCategory_s",
  "ProductCategory_s",
  "ProductBrandName_s",
  "ProductBrandNameDisplay_s",
  "ProductDescriptionProductShort_s",
  "productImages.labelWithUrl_ss",
  "slug_s",
  "id",
  "sku_s",
  "productImages.url_s",
  "productImages.url_ss",
  "RegionBrandName_ss",
  "productName_s",
  "productImage.url_ss",
  "CustomerFacingSKU_s",
  "productHeading_s",
  "ProductShape_s",
  "ProductStyle_ss",
  "ProductBowlShape_s",
  "ProductBowlStyle_s",
  "ProductWaterSense_s",
  "ProductHandleStyle_s",
  "ProductTrapwayType_s",
  "ProductConfiguration_s",
  "ProductPriceSegment_s",
  "ProductFeaturesFilter_ss",
  "ProductFlushingSystem_s",
  "ProductNumberofHoles_s",
  "ProductLitersPerFlush_s",
  "ProductHandleStyleType_s",
  "ProductInstallationType_ss",
  "ProductNumberofHandles_s",
  "ProductOverallWidthMm_i",
  "ProductOverallHeightMm_i",
];
export const EXCEPTIONAL_SITENAME = process.env.NEXT_PUBLIC_COUNTRY_NAME;
export const authorBaseUrl = process.env.NEXT_PUBLIC_BASEURL;
export const SWATCH_NA = "swatch_NA";
export const PLP_END_POINT_CLIENT = "/search/v1/plp";
export const LUCIDWORKS_PLP_URL = `https://kohler-dev.b.lucidworks.cloud/api/apps/${process.env.NEXT_PUBLIC_COUNTRY_NAME}/query/profile_${process.env.NEXT_PUBLIC_COUNTRY_NAME}_PLP`;

export const FILTERS_FL = [
  "Color.SKU.Details_ss",
  "ProductLocalCategory_s",
  "ProductCategory_s",
  "ProductBrandName_s",
  "ProductBrandNameDisplay_s",
  "ProductDescriptionProductShort_s",
  "productImages.labelWithUrl_ss",
  "ProductProductNo_s",
  "RegionReleaseforShipment_dt",
  "sku_s",
  "SKUColorFinishName_ss",
  "slug_s",
];

export const ALLOWED_PRICE_FACET = "priceList.GST.finalPrice_d";
export const siteName = process.env.NEXT_PUBLIC_COUNTRY_NAME;
export const lwAppName = process.env.NEXT_PUBLIC_COUNTRY_NAME;
export const PDP_END_POINT_SUBSCRIPTION_KEY = "/lw/pdp/";

export const SEARCH_PDP_FL = [
  "id",
  "sku_s",
  "slug_s",
  "productHeading_s",
  "CustomerFacingSKU_s",
  "Product_Category",
  "ProductLocalCategory_s",
  "ProductCategory_s",
  "ProductBrandNameDisplay_s",
  "Color.SKU.Details_ss",
  "productName_s",
  "productImages.labelWithUrl_ss",
  "ProductDescriptionProductShort_s",
  "ProductBrandName_s",
  "ProductWebFeatures_ss",
  "ProductWebTechnology_ss",
  "ProductNarrativeDescription_s",
  "ProductWebMaterial_ss",
  "ProductWebInstallation_ss",
  "ProductResource.DXFPlanView.resourceFullWebURL_ss",
  "ProductResource.DWGPlanView.resourceFullWebURL_ss",
  "ProductResource.DXFFrontView.resourceFullWebURL_ss",
  "ProductResource.DWGFrontView.resourceFullWebURL_ss",
  "ProductResource.DXFSideView.resourceFullWebURL_ss",
  "ProductResource.DWGSideView.resourceFullWebURL_ss",
  "ProductResource.3DDXFSymbol.resourceFullWebURL_ss",
  "ProductResource.3DDWGSymbol.resourceFullWebURL_ss",
  "ProductResource.3DRevit.resourceFullWebURL_ss",
  "ProductResource.3D3DS.resourceFullWebURL_ss",
  "ProductResource.3DSketchup.resourceFullWebURL_ss",
  "ProductResource.3DOBJ.resourceFullWebURL_ss",
  "ProductResource.SpecPDFFileName.resourceFullWebURL_ss",
  "ProductResource.SpecPDFFileName.resourceTitle_ss",
  "ProductResource.HomeownersGuide.resourceFullWebURL_ss",
  "ProductResource.HomeownersGuide.resourceTitle_ss",
  "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
  "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
  "ProductResource.InstallationWithoutSPPDF.resourceTitle_ss",
  "ProductResource.YouTubeInstallVideo.resourceName_ss",
  "ProductResource.YouTubeInstallVideo.resourceTitle_ss",
  "ProductProductNo_s",
  "CustomerFacingBrand_s",
  "title_s",
  "productImages.url_ss",
  "ProductDescriptionProduct_s",
  "pageDescription_s",
  "pageTitle_s",
  "canonicalUrl_s",
  "id",
  "buFilter_s",
  "pageType_s",
  "ProductMaterial_s",
  "RegionBrandName_ss",
  "Color.GST.Details_ss",
  "spec_s",
  "productImage.url_ss",
];
export const searchPdpEndPoint = "/search/pdp";

export const structuredPLPProfileName = (tag = "Toilets") =>
  `profile_${lwAppName}_PLP_${tag}`;

export const searchPLPEndPoint = "/search/plp";

export const masterPLPFL = [
  "Color.SKU.Details_ss",
  "Color.GST.Details_ss",
  "priceList.GST.finalPrice_d",
  "ProductBrandNameDisplay_s",
  "productImages.labelWithUrl_ss",
  "ProductLocalCategory_s",
  "ProductNarrativeDescription_s",
  "ProductCategory_s",
  "sku_s",
  "slug_s",
  "ProductBrandName_s",
  "ProductDescriptionProductShort_s",
  "productImages.url_s",
  "productImages.url_ss",
  "RegionBrandName_ss",
  "productName_s",
  "productImage.url_ss",
  "CustomerFacingSKU_s",
  "productHeading_s",
];

export const APIM_BASE_URL = `${process.env.NEXT_PUBLIC_BASEURL}/apirequest`;
export const searchSuggestionFL = [
  "sku_s",
  "slug_s",
  "url_s",
  "ProductCategory_s",
];

export const BRAND_REGISTRATION_SUBMIT_API = `${APIM_BASE_URL}/crm/brand/registration?channel=${process.env.NEXT_PUBLIC_CHANNEL_NAME || "apac"}`;
export const CONTACT_NOTIFICATION_FORM_SUBMIT_API = `${APIM_BASE_URL}/notification/form?type=internal&channel=${process.env.NEXT_PUBLIC_CHANNEL_NAME || "apac"}`;
export const EMAIL_SERVICE = "service_tw@kohler.com";
export const EMAIL_SENDER_SALE_SERVICE = "kohlerasiapacific@kohler.com";
export const DEFAULT_VISIBLE_FILTERS = 4; // Show 5 filter accordions by default

export const PDP_FL_payload = {
  q: "*:*",
  fl: [
    "id",
    "sku_s",
    "slug_s",
    "Color.GST.Details_ss",
    "CustomerFacingSKU_s",
    "ProductLocalCategory_s",
    "ProductBrandNameDisplay_s",
    "Color.SKU.Details_ss",
    "productName_s",
    "productImages.labelWithUrl_ss",
    "ProductDescriptionProductShort_s",
    "ProductBrandName_s",
    "ProductWebFeatures_ss",
    "ProductWebTechnology_ss",
    "ProductNarrativeDescription_s",
    "ProductWebMaterial_ss",
    "ProductWebInstallation_ss",
    "ProductResource.DXFPlanView.resourceFullWebURL_ss",
    "ProductResource.DWGPlanView.resourceFullWebURL_ss",
    "ProductResource.DXFFrontView.resourceFullWebURL_ss",
    "ProductResource.PartsPDFFileName.resourceName_ss",
    "ProductResource.DWGFrontView.resourceFullWebURL_ss",
    "ProductResource.DXFSideView.resourceFullWebURL_ss",
    "ProductResource.DWGSideView.resourceFullWebURL_ss",
    "ProductResource.3DDXFSymbol.resourceFullWebURL_ss",
    "ProductResource.3DRevit.resourceFullWebURL_ss",
    "ProductResource.3D3DS.resourceFullWebURL_ss",
    "ProductResource.3DSketchup.resourceFullWebURL_ss",
    "ProductResource.3DOBJ.resourceFullWebURL_ss",
    "ProductResource.SpecPDFFileName.resourceName_ss",
    "ProductResource.SpecPDFFileName.resourceFullWebURL_ss",
    "ProductResource.SpecPDFFileName.resourceTitle_ss",
    "ProductResource.HomeownersGuide.resourceFullWebURL_ss",
    "ProductResource.HomeownersGuide.resourceTitle_ss",
    "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
    "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
    "ProductResource.InstallationWithoutSPPDF.resourceTitle_ss",
    "ProductResource.YouTubeInstallVideo.resourceName_ss",
    "ProductProductNo_s",
    "ProductOverallHeightMm_i",
    "ProductOverallWidthMm_i",
    "title_s",
    "productImages.url_ss",
    "ProductDescriptionProduct_s",
    "pageDescription_s",
    "pageTitle_s",
    "canonicalUrl_s",
    "pageType_s",
    "RegionBrandName_ss",
    "ProductInstallationType_ss",
    "ProductResource",
    "ProductMaterial_s",
    "ProductCategory_s",
    "ProductSection_ss",
    "ProductResource.GIFLineArt.resourceAltText_ss",
    "ProductResource.GIFLineArt.resourceFullWebURL_ss",
    "productDiscontinued_b",
    "RegionRetailer1IMG_ss",
    "RegionRetailer1URL_ss",
    "fusion",
    "RegionRetailer4URL_ss",
  ].join(","),
  collections: process.env.NEXT_PUBLIC_COUNTRY_NAME,
  profilename: `profile_${process.env.NEXT_PUBLIC_COUNTRY_NAME}_PDP`,
};

export const PLP_PATTERN = /\/browse\/[^/]+\/Categories/i;
export const SEARCH_PATTERN = /^\/results\?/i;

export const InternalTitleToMatchForPDP = "product details country";

export const SEARCH_RESTRICT_PATTERN = /[^a-zA-Z0-9 '"-]/g;

export const LW_COUNTRY_FILTER_NAME = "KohlerPlumbing";
